import React, { Component } from "react";
import { Input, message, Row, Col, Upload, Tag, Space, notification, Spin, Alert } from "antd";
import { Form, FormItem, ButtonItem, ErrorItem } from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";
import { connect } from "react-redux";
import {
  UploadOutlined,
  LockOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import moment from "moment"

class DescargaMasivaConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    archivosCertificadoDM: [],
    archivoCertificadoDM: [],
    archivosLlavePrivadaDM: [],
    archivoLlavePrivadaDM: [],
    llavePrivadaDM: false,
    certificadoDM: false,
    passwordSATDM: false,
    certificadaDMMejorada: false,
    passwordSATDMMejorada: false,
    fechaVencimiento: null,
    loading: false
  };
  componentDidMount() {
    this.consultarConfiguracion();
  }
  onFinish(values) {
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    for (var key in values) {
      if (values[key] !== null) {
        fd.append(key, values[key]);
      }
    }
    if (this.state.archivoLlavePrivadaDM) {
      fd.append("llavePrivadaDM", this.state.archivoLlavePrivadaDM);
    }
    if (this.state.archivoCertificadoDM) {
      fd.append("certificadoDM", this.state.archivoCertificadoDM);
    }
    axios
      .post("empresas/editarConfiguracionDM", fd, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          message.success("Sus certificados fueron validados")
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("Los certificados se subieron pero no fueron validados");
          notification.error({
            message: 'Error',
            description: res.data.message,
            duration: null
          })
        } else {
          message.error(res.data.message || "Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post(
        "empresas/selectConfiguracionDM",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.setState({
            llavePrivadaDM: !!res.data.llavePrivadaDM,
            certificadoDM: !!res.data.certificadoDM,
            passwordSATDM: !!res.data.passwordSATDM,
            certificadaDMMejorada: !!res.data.certificadaDMMejorada,
            passwordSATDMMejorada: !!res.data.passwordSATDMMejorada,
            fechaVencimiento: res.data.fechaVencimientoFiel
              ? moment(res.data.fechaVencimientoFiel).format("DD/MM/YYYY")
              : null,
          });
        }
      });
    this.setState({ loading: false })
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  async onChangeArchivoCertificadoDM(e) {
    if (e.file.type === "application/x-x509-ca-cert") {
      this.setState({ archivosCertificadoDM: [e.file], archivoCertificadoDM: e.file });
    } else {
      message.error("El archivo debe ser de tipo .cer");
    }
  }
  async onChangeArchivoLlavePrivadaDM(e) {
    if (e.file.name.split('.').pop() === "key") {
      this.setState({ archivosLlavePrivadaDM: [e.file], archivoLlavePrivadaDM: e.file });
    } else {
      message.error("El archivo debe ser de tipo .key");
    }
  }
  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <DynamicCardForm
            title="Firma Electronica (Fiel)"
            style={{
              maxWidth: '98%',
              margin: '0 auto 12px auto',
              marginTop: '20px'
            }}
          >
            {(!this.state.certificadaDMMejorada || !this.state.passwordSATDMMejorada) && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
                message="Actualiza tus claves para obtener el nuevo servicio de descarga masiva"
                description="Mejoramos las consultas y eficacia del servicio de descarga masiva. Sube nuevamente tu certificado y contraseña SAT para activar el servicio mejorado."
              />
            )}
            <Form
              name="descargaMasivaConfiguracion"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              ref={this.formRef}
            >
              <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <FormItem
                    label="Fecha de vencimiento:"
                    colon={false}
                    margin
                  >
                    <span>{this.state.fechaVencimiento}</span>
                  </FormItem>
                  <FormItem
                    name="passwordSATDM"
                    margin
                    label="Contraseña SAT"
                    pattern
                    required
                  >
                    <Space>
                      <Input.Password
                        placeholder="Se remplazara al guardar"
                        prefix={<LockOutlined className="site-form-item-icon" />}
                      />
                      {this.state.passwordSATDM ? (
                        <Tag color="success" icon={<CheckOutlined />}>
                          Subido
                        </Tag>
                      ) : (
                        <Tag color="error" icon={<ExclamationCircleOutlined />}>
                          Faltante
                        </Tag>
                      )}
                    </Space>
                  </FormItem>
                  <FormItem required margin name="certificadoDM" label="Certificado (.cer)">
                    <Upload
                      accept=".cer"
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosCertificadoDM}
                      customRequest={this.onChangeArchivoCertificadoDM.bind(this)}
                    >
                      <Space>
                        <ButtonItem blanco icon={<UploadOutlined />}>Subir</ButtonItem>
                        {this.state.certificadoDM ? (
                          <Tag color="success" icon={<CheckOutlined />}>
                            Subido
                          </Tag>
                        ) : (
                          <Tag color="error" icon={<ExclamationCircleOutlined />}>
                            Faltante
                          </Tag>
                        )}
                      </Space>
                    </Upload>
                  </FormItem>
                  <FormItem required margin name="llavePrivadaDM" label="Clave privada (.key)">
                    <Upload
                      accept=".key"
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosLlavePrivadaDM}
                      customRequest={this.onChangeArchivoLlavePrivadaDM.bind(this)}
                    >
                      <Space>
                        <ButtonItem blanco icon={<UploadOutlined />}>Subir</ButtonItem>
                        {this.state.llavePrivadaDM ? (
                          <Tag color="success" icon={<CheckOutlined />}>
                            Subido
                          </Tag>
                        ) : (
                          <Tag color="error" icon={<ExclamationCircleOutlined />}>
                            Faltante
                          </Tag>
                        )}
                      </Space>
                    </Upload>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginTop: 16 }}>
                  <div
                    style={{
                      background: '#f7f9fa',
                      padding: '20px',
                      borderRadius: '8px',
                      height: '50%',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <div>
                      <p style={{ marginBottom: 0, lineHeight: 1.8 }}>
                        <InfoCircleOutlined style={{ marginRight: 8 }} />
                        Estos documentos seran procesados por nosotros para ofrecer el sistema de decarga masiva, comuníquese con nosotros si no se ha completado
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <ButtonItem
                cyan
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto", minWidth: 120, height: 30, }}
              >
                Guardar Configuración
              </ButtonItem>

            </Form>
          </DynamicCardForm>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(DescargaMasivaConfiguracion);
